import { Col, Descriptions, message, Row, Button } from "antd";
import { routes } from "common/routes";
import { AppPageHeader } from "components/AppPageHeader";
import { FormGroupIdentifier } from "components/FormGroupIdentifier/FormGroupIdentifier";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getVendorById } from "store/vendor/vendorSlice";
import { IVendor } from "common/interface/IVendor";

const MESSAGE_KEY = "view-vendor";

const ViewVendorPage = () => {
  const { vendors, status, error } = useAppSelector((state) => state.vendors);
  const [vendor, setVendor] = useState<IVendor>();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getVendorById({ vendorId: id }));
    } else {
      navigate(routes.VENDOR.ALL);
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (status === "loading") {
      message.loading({ content: "Loading vendor", key: MESSAGE_KEY });
    } else if (status === "error") {
      message.error({ content: error, key: MESSAGE_KEY });
    } else {
      message.destroy(MESSAGE_KEY);
    }

    return () => message.destroy(MESSAGE_KEY);
  }, [status, error]);

  useEffect(() => {
    const found = vendors?.data.find((v) => v.id.toString() === id);
    if (found) {
      setVendor(found);
    }
  }, [vendors, id]);

  const bank = vendor?.metadata?.bankAccountDetails;

  return (
    <>
      <Row justify="space-between" align="middle">
        <Col>
          <AppPageHeader title="Vendor Details" />
        </Col>
        <Col>
          <Button onClick={() => navigate(-1)}>Back</Button>
        </Col>
      </Row>

      {vendor && (
        <>
          <Row style={{ marginBottom: "1.5rem" }}>
            <Col xs={24}>
              <FormGroupIdentifier>Vendor Details</FormGroupIdentifier>
              <Descriptions
                size="small"
                bordered
                layout="vertical"
                labelStyle={{ fontWeight: "bold" }}
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="Vendor Name">{vendor.name || "—"}</Descriptions.Item>
                <Descriptions.Item label="Vendor Code">{vendor.vendorCode || "—"}</Descriptions.Item>
                <Descriptions.Item label="Point of Contact">{vendor.pocName || "—"}</Descriptions.Item>
                <Descriptions.Item label="Ext Vendor ID">{vendor.extVendorId || "—"}</Descriptions.Item>
                <Descriptions.Item label="PAN Number">{vendor.panNumber || "—"}</Descriptions.Item>
                <Descriptions.Item label="Supply Location">{vendor.location || "—"}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          <Row style={{ marginBottom: "1.5rem" }}>
            <Col xs={24}>
              <FormGroupIdentifier>Address Details</FormGroupIdentifier>
              <Descriptions
                size="small"
                bordered
                layout="vertical"
                labelStyle={{ fontWeight: "bold" }}
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="Address Line 1">{vendor.address?.address1 || "—"}</Descriptions.Item>
                <Descriptions.Item label="Address Line 2">{vendor.address?.address2 || "—"}</Descriptions.Item>
                <Descriptions.Item label="City">{vendor.address?.city || "—"}</Descriptions.Item>
                <Descriptions.Item label="State">{vendor.address?.state || "—"}</Descriptions.Item>
                <Descriptions.Item label="Pincode">{vendor.address?.pincode || "—"}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          <Row style={{ marginBottom: "1.5rem" }}>
            <Col xs={24}>
              <FormGroupIdentifier>Contact Details</FormGroupIdentifier>
              <Descriptions
                size="small"
                bordered
                layout="vertical"
                labelStyle={{ fontWeight: "bold" }}
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="Primary Phone">{vendor.primaryPhone || "—"}</Descriptions.Item>
                <Descriptions.Item label="Other Phone">{vendor.secondaryPhone || "—"}</Descriptions.Item>
                <Descriptions.Item label="Whatsapp Phone">{vendor.whatsappPhone || "—"}</Descriptions.Item>
                <Descriptions.Item label="Email">{vendor.email || "—"}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          <Row style={{ marginBottom: "1.5rem" }}>
            <Col xs={24}>
              <FormGroupIdentifier>Bank Details</FormGroupIdentifier>
              <Descriptions
                size="small"
                bordered
                layout="vertical"
                labelStyle={{ fontWeight: "bold" }}
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="Account Number">{bank?.accountNumber || "—"}</Descriptions.Item>
                <Descriptions.Item label="Account Name">{bank?.accountName || "—"}</Descriptions.Item>
                <Descriptions.Item label="Bank Name">{bank?.bankName || "—"}</Descriptions.Item>
                <Descriptions.Item label="IFSC Code">{bank?.ifscCode || "—"}</Descriptions.Item>
                <Descriptions.Item label="Branch Name">{bank?.branchName || "—"}</Descriptions.Item>
                <Descriptions.Item label="GST Number">{vendor.metadata?.gstin || "—"}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ViewVendorPage;
